import React from 'react';
import _ from 'lodash';
import propTypes from 'prop-types';
import RadioGroup from '../radio-group/radio-group';
import PhoneField from '../phone-field/phone-field';
import TextField from '../text-field/text-field';
import SelectField from '../select-field/select-field';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';
import validateLocation from './validator';
import {
	handleBlur, handleInputChange, getFormError, submitForm
} from '../../lib/form';
import filterPrefContactMethods from '../../lib/util/preferred-contact-methods';
import Icon from '../icon/icon';
import {
	SCHEDULE_ROUTE,
	PREFERRED_CONTACT_METHODS,
	LOCATION_TYPES,
	COUNTRIES,
	LOG_IN_ROUTE,
	CONTACT_ROUTE
} from '../../constants/constants';

class Location extends React.Component {
	constructor (props) {
		super(props);

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleBlur = handleBlur.bind(this);
		this.handleInputChange = handleInputChange.bind(this);

		this.state = {
			locationType: 'home',
			locationName: '',
			lesseeIsPresent: 'true',
			onSiteContactFirstName: '',
			onSiteContactLastName: '',
			onSiteContactPhone: '',
			onSiteContactPhoneType: 'mobile',
			onSiteContactEmail: '',
			onSiteContactPrefMethod: 'phone',
			country: 'US',
			street1: '',
			street2: '',
			city: '',
			state: '',
			zip: '',
			formErrors: [],
			blurredFields: []
		};
	}

	componentDidMount () {
		if (_.isEmpty(this.props.inspectionRequest)) {
			this.props.setRoute(LOG_IN_ROUTE);
		} else {
			this.props.setParentState({
				progressIndex: 2,
				canLogOut: false,
				canGoToHomePage: false
			});
		}
	}

	handleSubmit () {
		this.props.setParentState({
			lesseeIsPresent: this.state.lesseeIsPresent,
			onSiteContactFirstName: this.state.onSiteContactFirstName,
			onSiteContactLastName: this.state.onSiteContactLastName,
			onSiteContactPhone: this.state.onSiteContactPhone,
			onSiteContactPhoneType: this.state.onSiteContactPhoneType,
			onSiteContactEmail: this.state.onSiteContactEmail,
			onSiteContactPrefMethod: this.state.onSiteContactPrefMethod,
			locationType: this.state.locationType,
			location: {
				name: this.state.locationName,
				country: this.state.country,
				street1: this.state.street1,
				street2: this.state.street2,
				city: this.state.city,
				state: this.state.state,
				zip: this.state.zip
			}
		});
		this.props.setRoute(SCHEDULE_ROUTE);
	}

	render () {
		// Dispite changing the route in componentDidMount React will attempt to render this
		// at least once, so we're doing this to avoid a crash
		if (_.isEmpty(this.props.inspectionRequest)) {
			return (<div />);
		}

		const __ = mergeI18n(this.props.language, i18n);
		const formError = getFormError(this.state.blurredFields, this.state.formErrors, __.validation);
		const formSubmit = submitForm((!this.state.formErrors.length && !this.state.isFetchingAvailability), this.handleSubmit);

		document.title = `${__.titleStem} - ${__.pageTitle}`;

		return (
			<div id='lss-content'>
				<div id='location' className='row'>
					<div className='col-sm-12 col-md-6 col-md-offset-3'>
						<form onSubmit={formSubmit}>
							<h1>{__.inspectionLocation}</h1>
							<h2>{__.instructions}</h2>
							<div className='row'>
								<div className='col-xs-12 col-sm-6 col-md-5 location-column'>
									<SelectField
										label={__.locationType}
										name='locationType'
										value={this.state.locationType}
										options={LOCATION_TYPES[this.props.language]}
										emptyDefaultValue={true}
										ios={this.props.ios}
										placeholder={__.locationTypePlaceholder}
										onChange={this.handleInputChange}
										onBlur={(e) => this.handleBlur(e, validateLocation)}
										formError={formError('locationType')}
									/>

									<TextField
										label={__.locationName}
										placeholder={__.locationNamePlaceholder}
										name='locationName'
										value={this.state.locationName}
										onChange={this.handleInputChange}
										onBlur={(e) => this.handleBlur(e, validateLocation)}
										formError={formError('locationName')}
									/>

									<SelectField
										label={__.address}
										value={this.state.country}
										name='country'
										ios={this.props.ios}
										options={COUNTRIES}
										emptyDefaultValue={false}
										onChange={this.handleInputChange}
									/>

									<TextField
										placeholder={__.location.street1}
										name='street1'
										value={this.state.street1}
										onChange={this.handleInputChange}
										onBlur={(e) => this.handleBlur(e, validateLocation)}
										formError={formError('street1')}
									/>
									<TextField
										placeholder={__.location.street2}
										name='street2'
										value={this.state.street2}
										onChange={this.handleInputChange}
										onBlur={(e) => this.handleBlur(e, validateLocation)}
									/>

									<div className='row'>
										<div className='column col-xs-12 col-sm-4 city'>
											<TextField
												placeholder={__.location.city}
												name='city'
												value={this.state.city}
												onChange={this.handleInputChange}
												onBlur={(e) => this.handleBlur(e, validateLocation)}
												formError={formError('city')}
											/>
										</div>
										<div className='column col-xs-6 col-sm-4 state'>
											<SelectField
												name='state'
												value={this.state.state}
												options={COUNTRIES.find(c => c.value === this.state.country).states}
												ios={this.props.ios}
												placeholder={__.location.state}
												emptyDefaultValue={true}
												onChange={this.handleInputChange}
												onBlur={(e) => this.handleBlur(e, validateLocation)}
												formError={formError('state')}
											/>
										</div>
										<div className='column col-xs-6 col-sm-4 zip'>
											<TextField
												type={this.state.country !== 'CA' ? 'tel' : 'text'}
												placeholder={__.location.zip}
												name='zip'
												value={this.state.zip}
												onChange={this.handleInputChange}
												onBlur={(e) => this.handleBlur(e, validateLocation)}
												formError={formError('zip')}
											/>
										</div>
									</div>
								</div>

								<div className='col-xs-12 col-sm-6 col-md-5 col-md-offset-1 location-column presence-column'>
									<SelectField
										label={__.presence}
										value={this.state.lesseeIsPresent}
										name='lesseeIsPresent'
										ios={this.props.ios}
										options={[{ value: 'true', display: __.present }, { value: 'false', display: __.notPresent }]}
										emptyDefaultValue={false}
										onChange={this.handleInputChange}
									/>

									{this.state.lesseeIsPresent === 'true' ? null : (
										<div className='present-column'>
											<div className='row'>
												<span className='lss-form-label col-xs-12'>{__.onSiteContact}</span>
											</div>
											<div className='row on-site-contact'>
												<div className='column col-xs-6 first-name'>
													<TextField
														placeholder={__.firstName}
														name='onSiteContactFirstName'
														value={this.state.onSiteContactFirstName}
														onChange={this.handleInputChange}
														onBlur={(e) => this.handleBlur(e, validateLocation)}
														formError={formError('onSiteContactFirstName')}
													/>
												</div>

												<div className='column col-xs-6 last-name'>
													<TextField
														placeholder={__.lastName}
														name='onSiteContactLastName'
														value={this.state.onSiteContactLastName}
														onChange={this.handleInputChange}
														onBlur={(e) => this.handleBlur(e, validateLocation)}
														formError={formError('onSiteContactLastName')}
													/>
												</div>
											</div>

											<PhoneField
												language={this.props.language}
												label={__.inputs.phone.label}
												phoneName='onSiteContactPhone'
												phoneValue={this.state.onSiteContactPhone}
												phoneTypeName='onSiteContactPhoneType'
												phoneTypeValue={this.state.onSiteContactPhoneType}
												onChange={this.handleInputChange}
												onBlur={(e) => this.handleBlur(e, validateLocation)}
												formError={formError('onSiteContactPhone') || formError('onSiteContactPhoneType')}
											/>

											<TextField
												type='email'
												label={__.email}
												placeholder={__.emailPlaceholder}
												name='onSiteContactEmail'
												value={this.state.onSiteContactEmail}
												onChange={this.handleInputChange}
												onBlur={(e) => this.handleBlur(e, validateLocation)}
												formError={formError('onSiteContactEmail')}
											/>

											<div className='preferred-contact-row'>
												<RadioGroup
													label={PREFERRED_CONTACT_METHODS[this.props.language].label}
													name='onSiteContactPrefMethod'
													value={this.state.onSiteContactPrefMethod}
													onChange={this.handleInputChange}
													onBlur={(e) => this.handleBlur(e, validateLocation)}
													options={filterPrefContactMethods(this.props.language, this.state.onSiteContactPhoneType)}
													formError={formError('onSiteContactPrefMethod')}
													checked={this.state.onSiteContactPrefMethod}
													verticalLayout={true}
												/>

											</div>
											{this.state.onSiteContactPhoneType === 'mobile' && this.state.onSiteContactPrefMethod === 'sms' ? (
												<div className='sms-legal'>
													{__.smsLegal()}
												</div>
											) : null}
										</div>
									)}

								</div>
							</div>
							<div className='flex-button-spacer' />
							<div className='form-buttons-wrapper'>
								<div className='form-buttons'>
									<button id='back-button' className='btn btn-default back-button' type='button' onClick={() => this.props.setRoute(CONTACT_ROUTE)}><Icon name='MdChevronLeft' /> {__.backButton}</button>
									<button
										id='submit-form'
										className='btn btn-primary continue-button'
										type='submit'
										disabled={this.state.formErrors.length > 0 || this.state.blurredFields.length === 0 || this.props.isFetchingAvailability}
									>
										{__.continueButton} <Icon name='MdChevronRight' />
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

Location.propTypes = {
	inspectionRequest: propTypes.shape({
		confirmationNo: propTypes.number,
		clickTaskType: propTypes.string,
		lesseeFirstName: propTypes.string,
		lesseeLastName: propTypes.string,
		lesseeEmail: propTypes.string,
		vehicles: propTypes.arrayOf(propTypes.shape({
			vin: propTypes.string.isRequired,
			make: propTypes.string,
			model: propTypes.string,
			year: propTypes.string
		}))
	}),
	language: propTypes.string.isRequired,
	isIOS: propTypes.bool.isRequired,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired
};
export default Location;
